import { useMemo } from 'react'
import type { IconNodeType } from './icons'

export function useIconMap(icons: [string, IconNodeType][]) {
	const iconMap = useMemo(() => new Map<string, IconNodeType>(icons), [icons])
	const hasIcon = (name: string) => iconMap.has(name)
	const getIconNode = (name: string): IconNodeType | undefined =>
		iconMap.get(name)
	return { iconMap, hasIcon, getIconNode }
}
